import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({directives:[{name:"shortkey",rawName:"v-shortkey",value:(_vm.action.shortkey),expression:"action.shortkey"}]},'v-btn',_vm.getActionButtonProps.props,false),_vm.getActionButtonProps.events),[_vm._v(" "+_vm._s(_vm.getLabelWithShortkey(_vm.action.label, _vm.action.shortkey['key']))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }